import React from 'react';
import * as styles from './agency-memberships.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AgencyMemberships = _ref => {
  var agencyName = _ref.agencyName,
    _ref$memberships = _ref.memberships,
    memberships = _ref$memberships === void 0 ? [] : _ref$memberships;
  return ___EmotionJSX("div", {
    css: styles.agencyMemberships
  }, memberships.length > 0 && ___EmotionJSX("div", {
    css: styles.agencyMembershipCategory
  }, ___EmotionJSX("h3", {
    css: styles.title
  }, "Distinctions"), ___EmotionJSX("div", {
    css: styles.sectionDescription
  }, "Find out the locations where ", agencyName, " has registered members"), memberships.map(membership => ___EmotionJSX("div", {
    css: styles.agencyMembership
  }, membership.logoUrl && ___EmotionJSX("div", null, ___EmotionJSX("img", {
    src: membership.logoUrl,
    alt: membership.name,
    css: styles.agencyMembershipLogo
  })), ___EmotionJSX("div", {
    css: styles.agencyMembershipContent
  }, ___EmotionJSX("div", {
    css: styles.membershipName
  }, membership.name), ___EmotionJSX("div", {
    css: styles.membershipDescription
  }, membership.description))))));
};
export default AgencyMemberships;